import { render, staticRenderFns } from "./SpecialOfferItem.vue?vue&type=template&id=18a64632&"
import script from "./SpecialOfferItem.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports